import type { PrototyperPermissionApi } from 'api-typings/canvas/canvas';
import type { PrototyperPermission } from './prototyper-permissions.model';

export function transformPrototyperPermissions(
  permission: PrototyperPermissionApi,
): PrototyperPermission {
  return {
    id: permission.id,
    canvasId: permission.canvas_id,
    principalType: permission.principal_type,
    principalId: permission.principal_id,
    accessRole: permission.access_role,
    createdAt: permission.created_at * 1000,
    deletedAt: permission.deleted_at ? permission.deleted_at * 1000 : undefined,

    /** Only displayed to FL-ADMINs (with admin_id and auth hash) */
    creatorType: permission.creator_type ?? undefined,
    creatorId: permission.creator_id ?? undefined,
    deleterType: permission.deleter_type ?? undefined,
    deleterId: permission.deleter_id ?? undefined,
  };
}
